






import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import _ from "lodash";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component
export default class AccountTypeSubheader extends Vue {
  @Prop({ required: false })
  accountId: number;

  drivewealthStore = useDrivewealthStore();

  get accountTypeDisplayCopy (): string {
      return this.drivewealthStore.accountManagementTypeTitle(this.accountId);
  }

}
